<template>
  <b-row no-gutters class="footer" >
    <b-col>
      <slot />
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style lang="scss" scoped>
  @import '@design';

  .footer {
    padding: 25px;
    font-weight: bold;
    color: $color-container-text;
    text-align: center;
    background-color: $color-container-bg;
  }
</style>
